import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { MemberFilterSelectedValues } from '../../../configs/member-filter-config/filter-selected-values';
import { membersFilterConfig } from '../../../configs/member-filter-config';

export const TaskReporterFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Created by'
      renderValues={MemberFilterSelectedValues}
      config={membersFilterConfig({ facetName: 'reporter' })}
    />
  );
};
